import React,{useEffect,useState,useRef} from 'react';
import styled from 'styled-components';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import { AppState } from '../../store';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { setCurrentCategory, setSubCategoriesStatus,getCategory } from '../../store/categories/functions';
import { Card, CardActionButton, DescriptionBox } from '../elements';
import { finder, fetchPostItem } from '../../store/posts/functions';
import { Post } from '../../store/posts/types';
import FormViewItem, { FormViewItemEnum } from '../elements/formViewItem';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView'
import { LabInterface } from '../../store/base/types';
import { BASE_MEDIA_URL } from '../../inc/constants';
import { CONSTS } from '../elements/_constants';
type PostItemComponentProps = {
    className?: string,
    match: any,
    onSetCurrentCategoryId: Function,
    onToggleSubCategories: Function,
    onFetchPostItem: Function,
    currentCategoryId: number,
    currentCategory: any,
    categories: any,
    currentPost?: Post,
    currentLab: LabInterface
}

// TODO: PostMeta Component
type PostMetaComponentProps = {
  className? : string
  currentPost: any,
  currentLab: any
}
const PostMetaComponent = (props:PostMetaComponentProps) => (
  <div className={props.className}>
    <div className="logo">
      <img src={props.currentLab.logo && `${BASE_MEDIA_URL}${props.currentLab.logo.medium}`}/>
    </div>
    <div className="data">
      
      <div className="caption">شماره سند:</div>
      <div className="value">{props.currentPost.unique_id}</div>
      <div className="caption">تاریخ ایجاد سند:</div>
      <div className="value">{props.currentPost.created_datetime}</div>
      <div className="caption">تعداد ویرایش:</div>
      <div className="value">{props.currentPost.meta && props.currentPost.meta.edit_number}</div>
      <div className="caption">تاریخ آخرین ویرایش:</div>
      <div className="value">{props.currentPost.updated_datetime}</div>
    </div>
  </div>
)
const PostMeta = styled(PostMetaComponent)`
  display: flex;
  flex-direction: row-reverse;
  margin: 15px 25px 0;
  font-size: 13px;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
  .logo{
    width: 140px;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    img{
      max-width: 100%;
    }
  }
  .data{
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    color: #999;
    .caption{
      width: 20%;
      margin: 3px 0;
    }
    .value{
      width: 30%;
      font-weight: bold;
    }
  }
`

// TODO: PostSignature Component
type PostSignatureType = {
  user :string,
  timestamp : string,
  image :any
}
type SignatureComponentProps = {
  className? :string,
  signature : any
}
const SignatureComponent = (props:SignatureComponentProps) => (
  <div className={props.className}>
    <div className="_image">
      <img src={`${BASE_MEDIA_URL}${props.signature.image.medium}`} />
    </div>
    <div className="_desc">
      امضاء: <b className="_user">{props.signature.user}</b> <br/>
      در <b className="_date">{props.signature.timestamp}</b>
      {/* امضاء شده توسط <b>{props.signature.user}</b> در تاریخ <b>{props.signature.timestamp}</b> */}
    </div>
  </div>
)
export const Signature = styled(SignatureComponent)`
  text-align: left;
  padding: 15px;
  ._image{
    width: 200px;
    margin-right: auto;
    img{
      max-width: 100%;
    }
  }
  ._desc{
    width: 200px;
    margin-right: auto;
    font-size: 12px;
    text-align: center;
  }
`

const PostItemComponent = (props: PostItemComponentProps) => {
    useEffect(() => {
        props.onFetchPostItem(parseInt(""+props.match.params.postId));
    },[])
    return (
      <div className={props.className}>
          {props.currentPost &&
            <Card
              className="_card"
              title={props.currentPost.title}
              headerMeta={<>
                <CardActionButton className="_meta-btn" title="ویرایش" to={`${props.match.url}/edit`} iconClassName="icon-icons8-pencil" hasBorderRight={true}/>
                <CardActionButton className="_meta-btn" title="چاپ" onClick={() => window.print()} hasBorderRight={true}/>
              </>}
            >
              {(props.currentPost && (props.currentPost.meta && props.currentPost.meta.verified)) ? 
                  <PostMeta currentLab={props.currentLab} currentPost={props.currentPost} />
                :
                <div className="not-verified-alert">این مدرک توسط مسئول مربوطه تایید و امضاء نشده است.</div>
              }
              {props.currentPost.description && props.currentPost.description.length > 229 && <DescriptionBox content={<FroalaEditorView model={props.currentPost.description} />} style={{margin:10}}/>}
              <FormViewItem value={props.currentPost.content} type={FormViewItemEnum.Editor}/>
              {props.currentPost.images && props.currentPost.images.length != 0 && <FormViewItem label="تصاویر پیوست" value={props.currentPost.images} type={FormViewItemEnum.Image}/>}
              {(props.currentPost && (props.currentPost.meta && props.currentPost.meta.signature)) && 
                <Signature signature={props.currentPost.meta.signature} />
              }
            </Card>
          }
        </div>

    )
}

const PostItem = styled(PostItemComponent)`
  .not-verified-alert{
    color: ${CONSTS.colors.warningDark};
    border: 1px solid;
    border-radius: 15px;
    background-color: ${CONSTS.colors.warningLight};
    padding: 10px 15px;
    margin: 10px 15px;
  }
  @media only print {
    .not-verified-alert{
      display: none;
    }
    border: none;
    margin-left: 0;
    border-radius: 0;
    ._card{
      border: none;
    }
    ._meta-btn{
      display: none;
    }
}
`

const mapStateToProps = (state: AppState,ownProps: any) => ({
  categories: state.categories,
  currentCategory: getCategory(state.categories.items,state.categories.currentCategoryId),
  currentCategoryId: state.categories.currentCategoryId,
  currentPost: findPost(ownProps.match.params.postId,state.posts.posts),
  currentLab: state.base.lab
});

function findPost(postId: any,posts: Post[]) {
  if(!postId || !posts) return;
  let postIndex = finder(parseInt(""+postId),posts);
  return posts[postIndex];
}

const mapDispatchToProps = (dispatch:any) => {
    return {
      onSetCurrentCategoryId  : (id: number)      =>{
        dispatch(setCurrentCategory(id));
      },
      onToggleSubCategories   : (open: boolean)   =>{
        dispatch(setSubCategoriesStatus(open));
      },
      onFetchPostItem: (id: number) => {
        dispatch(fetchPostItem(id))
      }
    };
  };
  
  export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(PostItem));


          // <div className={props.className} style={{fontFamily:'dana',paddingLeft:29}}>
        //     {props.match.params.postId}.{postItem.title}
        //     <FroalaEditorComponent config={EditorConfig} model={model} onModelChange={(m:any)=>setModel(m)} tag='textarea'/>
        // </div>
        // Require Editor CSS files.
// import 'froala-editor/css/froala_style.min.css';
// import 'froala-editor/css/froala_editor.pkgd.min.css';
// import 'froala-editor/js/languages/fa';
// import 'froala-editor/js/plugins.pkgd.min.js';
// ///<reference path= "./../../inc/froala.d.ts" />
// import FroalaEditorComponent from 'react-froala-wysiwyg';
